import React from 'react'
import { RichTextBlock } from 'prismic-reactjs'
import Card from 'atoms/surfaces/card/Card'
import CardMedia from 'atoms/surfaces/card/CardMedia'
import CardContent from 'atoms/surfaces/card/CardContent'
import RichMultiText from 'molecules/display/RichMultiText'
import RichTitle from 'molecules/display/RichTitle'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Box from 'atoms/layout/Box'
import Grid from 'atoms/layout/Grid'

type ImageContentCardProps = {
  url: string
  title: RichTextBlock[] | null
  contents: RichTextBlock[] | null
}

const useStyles = makeStyles(theme => createStyles({
  eyeCatching: {
    height: '10rem',
    [theme.breakpoints.up('sm')]: {
      height: '15rem'
    },
    [theme.breakpoints.up('md')]: {
      height: '25rem'
    }
  }
}))

export default function ImageContentCard ({
  url, title, contents
}: ImageContentCardProps) {
  const classes = useStyles()

  return (
    <Card>
      <CardMedia image={url} className={classes.eyeCatching}/>
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <RichTitle content={title}/>
          </Grid>
          <Grid item xs={12}>
            <Box px={4}>
              <RichMultiText content={contents}/>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
